import { render, staticRenderFns } from "./SignUpCalendarBlock.vue?vue&type=template&id=12237ad8"
import script from "./SignUpCalendarBlock.vue?vue&type=script&lang=js"
export * from "./SignUpCalendarBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports